import { Notification } from '@app/components/various/Notification';
import { isDefined } from '@app/utils/is';
import { Notifications } from '@typings';

interface Props {
  type?: Notifications.NotificationType;
  message: Maybe<string>;
  isBordered?: boolean;
}

export const FormNotification = ({ type = 'error', message, isBordered }: Props) => {
  if (!isDefined(message)) {
    return null;
  }

  return <Notification type={type} role="status" className="mt-4" isBordered={isBordered} message={message} />;
};
